import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Dashboard/Dashboard';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="bamboo-loader">
          <div className="bamboo-segment"></div>
          <div className="bamboo-segment"></div>
          <div className="bamboo-segment"></div>
        </div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading-container">
        <div className="bamboo-loader">
          <div className="bamboo-segment"></div>
          <div className="bamboo-segment"></div>
          <div className="bamboo-segment"></div>
        </div>
      </div>
    );
  }
  
  return user ? <Navigate to="/dashboard" /> : children;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: 'var(--bamboo-cream)',
                color: 'var(--bamboo-dark)',
                border: '1px solid var(--bamboo-light)',
                borderRadius: '12px',
                boxShadow: '0 4px 12px var(--shadow-medium)',
              },
              success: {
                iconTheme: {
                  primary: 'var(--bamboo-green)',
                  secondary: 'white',
                },
              },
              error: {
                iconTheme: {
                  primary: '#e53e3e',
                  secondary: 'white',
                },
              },
            }}
          />
          
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } 
            />
            <Route 
              path="/register" 
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
